import axios from "axios";

// Custom Component
// import DoRefreshToken from '../components/SignIn/DoRefreshToken'
import SignOut from "../components/SignIn/SignOut";
const store = require("store");

const getRFIList = async (is_draft) => {
  const getRFIAPI = `/rfi?is_draft=${is_draft}`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3010 + getRFIAPI,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getRFIDetails = async (rfi_seq) => {
  const getRFIDetailsAPI = `/rfi/${rfi_seq}`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3010 + getRFIDetailsAPI,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getRfiStageList = async (stage_seq) => {
  const RfiStageListAPI = `/rfi/attr/${stage_seq}/stage`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3010 + RfiStageListAPI,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const insertRFIResponse = async (rfi_seq, response_seq, params) => {
  const insertRFIResponseAPI = `/rfi/${rfi_seq}/response/${response_seq}`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };
    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3010 + insertRFIResponseAPI,
      headers: headers,
      data: params,
    });
    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const updateRFIResponse = async (rfi_seq, response_seq, params) => {
  const updateRFIResponseAPI = `/rfi/${rfi_seq}/response/${response_seq}`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };
    result = await axios({
      method: "patch",
      url: process.env.REACT_APP_API_URL_3010 + updateRFIResponseAPI,
      headers: headers,
      data: params,
    });
    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const comfirmRFIResponse = async (rfi_seq, response_seq, params) => {
  const confirmRFIResponseAPI = `/rfi/${rfi_seq}/response/${response_seq}/confirm`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };
    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3010 + confirmRFIResponseAPI,
      headers: headers,
      data: params,
    });
    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const insertRFIComment = async (rfi_seq, params) => {
  const insertRFICommentAPI = `/rfi/${rfi_seq}/comment`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3010 + insertRFICommentAPI,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const insertRFIReturnComment = async (rfi_seq, params) => {
  const insertRFIReturnCommentAPI = `/rfi/${rfi_seq}/returncomment`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3010 + insertRFIReturnCommentAPI,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const createRFI = async (params) => {
  const createRFIAPI = `/rfi`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3010 + createRFIAPI,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const insertStageAction = async (params) => {
  const insertStageActionAPI = `/rfi/stageaction`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3010 + insertStageActionAPI,
      headers: headers,
      data: params,
    });
    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const updateRFI = async (rfi_seq, params) => {
  const updateRfiAPI = `/rfi/${rfi_seq}`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "patch",
      url: process.env.REACT_APP_API_URL_3010 + updateRfiAPI,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getRFICategoryList = async () => {
  const getRFICategories = `/rfi/attr/category`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3010 + getRFICategories,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const updateRFIStage = async (rfi_seq, params) => {
  const updateRFIStageAPI = `/rfi/${rfi_seq}/stage`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "patch",
      url: process.env.REACT_APP_API_URL_3010 + updateRFIStageAPI,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const updateRFIApproveStage = async (rfi_seq, params) => {
  const updateRFIApproveStageAPI = `/rfi/${rfi_seq}/approve`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "patch",
      url: process.env.REACT_APP_API_URL_3010 + updateRFIApproveStageAPI,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const updateRFISendFlag = async (rfi_seq, params) => {
  const updateRFISendFlagAPI = `/rfi/${rfi_seq}/send`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "patch",
      url: process.env.REACT_APP_API_URL_3010 + updateRFISendFlagAPI,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const generateRFI = async (params) => {
  const generateRFIAPI = `/rfi/download/rfi`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3010 + generateRFIAPI,
      headers: headers,
      data: params,
      responseType: "blob",
    }).then((response) => {
      const blob = new Blob([response.data], { type: response.data.type });
      const downloadUrl = window.URL.createObjectURL(blob);
      // var reader = new FileReader();
      // reader.readAsDataURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      const header_filename = response.headers["download-filename"];
      let filename = "date_time";
      if (header_filename) {
        filename = decodeURIComponent(header_filename);
      }
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const saveRFI = async (params) => {
  const saveRFIAPI = `/rfi/download/rfi/upload`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3010 + saveRFIAPI,
      headers: headers,
      data: params,
    });
    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getUnreadRfiCount = async () => {
  const getUnreadRFIAPI = `/rfi/unread/count`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3010 + getUnreadRFIAPI,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const transferRFItoEfiling = async (params) => {
  const transferRFIAPI = `/rfi/transfer`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };
    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3010 + transferRFIAPI,
      headers: headers,
      data: params,
    });
    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getRfiDuplicate = async (manual_ref_no) => {
  const getRfiDuplicate = `/rfi/checkduplicate/${manual_ref_no}`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3010 + getRfiDuplicate,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

export {
  getRFIList,
  getRfiStageList,
  getRFIDetails,
  insertRFIComment,
  insertRFIReturnComment,
  insertRFIResponse,
  updateRFIResponse,
  comfirmRFIResponse,
  createRFI,
  updateRFI,
  getRFICategoryList,
  updateRFIStage,
  updateRFISendFlag,
  generateRFI,
  saveRFI,
  insertStageAction,
  getUnreadRfiCount,
  updateRFIApproveStage,
  transferRFItoEfiling,
  getRfiDuplicate,
};
